import { ChevronRight } from "lucide-react";
import type { QuestionnaireSummaryCta, QuestionnaireSummaryListItem } from "@ferrivia/api-contract";
import { useFormatters, useTranslation } from "@ferrivia/i18n";
import { Text } from "@ferrivia/ui";
import { useAppContext } from "../app/useAppContext";
import s from "./SummaryList.module.css";

export interface SummaryListProps {
  summaries: readonly QuestionnaireSummaryListItem[];
  path: QuestionnaireSummaryCta;
}

export function SummaryList({ summaries, path }: SummaryListProps) {
  const { t } = useTranslation("client");
  const { date, time } = useFormatters();
  const { openSummary } = useAppContext();

  if (summaries.length === 0) {
    return null;
  }

  return (
    <section className={s.root}>
      <Text as="h2" size="lg" weight="bold" className={s.heading}>
        {t("summary.list.title", "Raportit")}
      </Text>
      <ul className={s.list}>
        {summaries.map((summary) => {
          const submittedAt = new Date(summary.submittedAt);
          return (
            <li key={summary.id}>
              <button type="button" className={s.row} onClick={() => openSummary(summary.id, { source: "summary_list", path })}>
                <span className={s.text}>
                  <Text as="span" size="md" weight="medium">
                    {t("summary.title", "Henkilökohtainen rautaraporttisi")}
                  </Text>
                  <span className={s.when}>
                    {t("summary.list.when", "{{date}} klo {{time}}", {
                      date: date.format(submittedAt),
                      time: time.format(submittedAt),
                    })}
                  </span>
                </span>
                <ChevronRight aria-hidden size={20} className={s.chevron} />
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
